'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _commonFunctions = require('../../helpers/commonFunctions');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a Stripe Credit Card input component along with a corresponding label.
 */
var StripeCreditCardComponent = function (_React$Component) {
  _inherits(StripeCreditCardComponent, _React$Component);

  function StripeCreditCardComponent() {
    _classCallCheck(this, StripeCreditCardComponent);

    return _possibleConstructorReturn(this, (StripeCreditCardComponent.__proto__ || Object.getPrototypeOf(StripeCreditCardComponent)).apply(this, arguments));
  }

  _createClass(StripeCreditCardComponent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBootstrap.Form,
        { id: 'payment-form' },
        (0, _commonFunctions.rimiVTCProducts)(this.props.source) && this.props.fields.payment.payment_option.value !== 'monthly' ? _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'paymentAmount',
          inputLabel: (0, _translate.t)('Payment Amount'),
          inputComponent: _TextInputComponent2.default,
          inputComponentField: this.props.fields.payment.amount
        }) : null,
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'creditCardHolderName',
          inputLabel: (0, _translate.t)('Cardholder Name'),
          inputComponent: _TextInputComponent2.default,
          inputComponentField: this.props.fields.payment.cardholder_name
        }),
        _react2.default.createElement(
          'div',
          { className: 'form-row' },
          _react2.default.createElement('label', { htmlFor: 'card-element' }),
          _react2.default.createElement('div', { id: 'card-element' }),
          _react2.default.createElement('div', { id: 'card-errors', role: 'alert' })
        )
      );
    }
  }]);

  return StripeCreditCardComponent;
}(_react2.default.Component);

StripeCreditCardComponent.propTypes = {
  fields: _react2.default.PropTypes.object,
  source: _react2.default.PropTypes.object
};
exports.default = StripeCreditCardComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/StripeCreditCardComponent.jsx
// module id = 1674
// module chunks = 0